import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeypointDisabled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .2,
		children: [/* @__PURE__ */ _jsx("rect", {
			x: 8.10049,
			y: 18,
			width: 14,
			height: 14,
			rx: 2,
			transform: "rotate(-45 8.10049 18)",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17 14H19V17H22V19H19V22H17V19H14V17H17V14Z",
			fill: "white"
		})]
	})
});
const ForwardRef = forwardRef(SvgKeypointDisabled);
export { ForwardRef as ReactComponent };
